import { ValidatorTypes } from "../../../../util/validators";
import { PROJECT_TYPE, QUOTE_TYPE } from "../../../../util/enums";

export const AddProjectFields = {
    profitMarginValue: {
        name: "profitMarginValue",
        label: "Profit Margin %",
        type: "number",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Profit Margin %",
    },
    projectName: {
        name: "projectName",
        label: "Project Name",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Project Name",
    },
    prefix: {
        name: "prefix",
        label: "Prefix",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.OPTIONAL],
        "data-cy": "Prefix",
    },
    suffix: {
        name: "suffix",
        label: "Suffix",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.OPTIONAL],
        "data-cy": "Suffix",
    },
    autoCalculateRetention: {
        name: "autoCalculateRetention",
        label: "Auto Calculate Retention",
        type: "checkbox",
        touched: false,
        error: false,
        valid: true,
        value: false,
        validation: [ValidatorTypes.OPTIONAL],
        "data-cy": "autoCalculateRetention",
    },
    showRetentions: {
        name: "showRetentions",
        label: "Show Retention",
        type: "checkbox",
        touched: false,
        error: false,
        valid: true,
        value: false,
        validation: [ValidatorTypes.OPTIONAL],
        "data-cy": "showRetentions",
    },
    showVariations: {
        name: "showVariations",
        label: "Show Variation",
        type: "checkbox",
        touched: false,
        error: false,
        valid: true,
        value: false,
        validation: [ValidatorTypes.OPTIONAL],
        "data-cy": "showVariations",
    },
    useRevisedProjectTotal: {
        name: "useRevisedProjectTotal",
        label: "Use Revised Project Total",
        type: "checkbox",
        touched: false,
        error: false,
        valid: true,
        value: true,
        validation: [ValidatorTypes.OPTIONAL],
        "data-cy": "useRevisedProjectTotal",
    },
    maxRetentionPercentage: {
        name: "maxRetentionPercentage",
        label: "Maximum Retention %",
        type: "number",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.NUMBER, ValidatorTypes.PERCENTAGE],
        "data-cy": "maxRetentionPercentage",
    },
    defaultRetentionPercentage: {
        name: "defaultRetentionPercentage",
        label: "Default Retention %",
        type: "number",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.NUMBER, ValidatorTypes.PERCENTAGE],
        "data-cy": "defaultRetentionPercentage",
    },
    address: {
        name: "address",
        label: "Address",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "",
        items: [],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Address",
    },
    manager: {
        name: "manager",
        label: "Project Manager",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "",
        items: [],
        validation: [ValidatorTypes.SKIP, ValidatorTypes.REQUIRED],
        "data-cy": "Project Manager",
    },
    customer: {
        name: "customer",
        label: "Customer",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "",
        items: [],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Customer",
    },
    contact: {
        name: "contact",
        label: "Customer Contact",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "",
        items: [],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Customer Contact",
    },
    date: {
        name: "date",
        label: "Created(Date)",
        type: "datepicker",
        touched: false,
        error: false,
        valid: true,
        value: new Date(),
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Created Date",
    },
    startDate: {
        name: "startDate",
        label: "Project Start Date",
        type: "datepicker",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.SKIP, ValidatorTypes.REQUIRED],
        "data-cy": "Project Start Date",
    },
    budget: {
        name: "budget",
        label: "Budget",
        type: "number",
        touched: false,
        error: false,
        valid: true,
        disable: false,
        value: "",
        validation: [ValidatorTypes.SKIP, ValidatorTypes.REQUIRED],
        "data-cy": "Budget",
    },
    level: {
        name: "level",
        label: "Cost/Sales Level",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "",
        items: [],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Cost/Sales Level",
    },
    category: {
        name: "category",
        label: "Project Category",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "",
        items: [],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Project Category",
    },
    projectQuoteType: {
        name: "projectQuoteType",
        label: "Project Type",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        items: [
            { value: QUOTE_TYPE.QUOTE, key: "Quote" },
            { value: QUOTE_TYPE.NOQUOTE, key: "No Quote" },
        ],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Project Type",
    },
    projectType: {
        name: "projectType",
        label: "Project Type",
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: PROJECT_TYPE.PROJECT,
        items: [
            { value: PROJECT_TYPE.PROJECT, key: "Project" },
            { value: "Services", key: "Services" },
        ],
        validation: [ValidatorTypes.REQUIRED],
        "data-cy": "Project Type",
    },
    description: {
        name: "description",
        label: "Description(optional)",
        type: "textarea",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.TEXTAREA],
        "data-cy": "Description",
    },
    exclusions: {
        name: "exclusions",
        label: "Exclusions(optional)",
        type: "textarea",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [ValidatorTypes.TEXTAREA],
        "data-cy": "Exclusions",
    },
    attachments: {
        name: "attachments",
        label: "Attachments",
        type: "file",
        touched: false,
        error: false,
        valid: true,
        multiple: true,
        value: [],
        attachmentArr: [],
        validation: [],
        "data-cy": "Attachments",
    },
    address_breakdown: {
        name: "address_breakdown",
        label: "Address Breakdown",
        type: "hidden",
        touched: false,
        error: false,
        valid: true,
        value: null,
        validation: [ValidatorTypes.SKIP],
        "data-cy": "Address Breakdown",
    }
}